export default __webpack_public_path__ + "static/IDMC_GRID_2022 En bref-Déplacements internes en 2021-29531cdfcf26c3f4cb8e35d60c0f0c23.jpg";